import { handleAjaxError } from '../actions/handleAjaxError';

function generatorAccessGate() {
    document.addEventListener('growtypeGeneratorAccessDenied', function (event) {
        const responseJSON = event.detail?.responseJSON;

        if (responseJSON?.data?.message !== 'subscription_required') {
            return;
        }

        event.preventDefault();
        handleAjaxError({ responseJSON });
    });
}

export { generatorAccessGate };
